import cx from "classnames";
import type { Element } from "React";
import "./IconCorner.scss";
type Props = {
  className?: string;
};

const IconCorner = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    className={cx(props.className, "icon__icon-corner")}
  >
    <title id="title">Corner</title>
    <path d="M6 12V1M10.382 3L6 .809v4.382L10.382 3z" />
    <path d="M.68 7.713V6.478l5.896 4.28a1 1 0 0 1-.082 1.672L.679 15.836v-1.159l5.31-3.11-5.31-3.854z" />
    <path d="M3 14c-1.333-2-1.333-3.667 0-5" />
  </svg>
);

export default IconCorner;
